
export const globalTranslateFireStatus = (status: string = ""): string => {
	const s = status.toLowerCase();
	if (s === "pending") return "Pendente";
	if (s === "open") return "Aguardando contratação";
	if (s === "expired") return "Expirado";
	if (s === "canceled") return "Cancelado";
	if (s === "sending") return "Enviando";
	if (s === "hired") return "Contratado";
	return status;
};


export const globalTranslateFireStatusPolices = (status: string = ""): string => {
	const s = status.toLowerCase();
	if (s === "pending") return "Pendente";
	if (s === "open") return "Vigente";
	if (s === "expired") return "Expirado";
	if (s === "canceled") return "Cancelado";
	if (s === "canceling") return "Enviando";
	if (s === "to_invoice") return "Apolice a faturar";
	return status;
};